import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useParams, useNavigate } from 'react-router-dom'

import ComboBox from '../../../../../../Components/ComboBox'
import CustomButton from '../../../../../../Components/CustomButton/CustomButton'
import { Input } from '../../../../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../../../../utils/api'
import { currentDate } from '../../../../../../utils/helpers'
import urls from '../../../../../../utils/urls'

export default function CreateOperationForm({ setOperations }) {
  const { id } = useParams()
  const [open, setOpen] = useState(false)

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      immobilier: id,
      date_value: currentDate(),
      market_value: '',
    },
  })

  // useEffect( () =>
  // {
  //   fetchMotorTypes();
  //   fetchBoatTypes();
  // }, [] );

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = {
      ...data,
    }

    const response = await makePostRequest(urls.crudImmoValueOperations, payload, {}, true)
    if (response.status === 201) {
      setOperations((operations) => ({
        ...operations,
        results: [...operations.results, response.data],
        count: operations.count + 1,
      }))
      handleClose()
    }
  }

  return (
    <>
      <CustomButton onClick={handleClickOpen}>créer</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        <DialogTitle>Ajouter valorisation</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'date',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="date_value"
              label="Date"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'number',
                required: true,
                size: 'small',
              }}
              rules={{ required: true }}
              name="market_value"
              label="Valeure"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
